import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import axios from 'axios';

// Admin Pages
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminMessages from './pages/AdminMessages';

// Pages
import HomePage from './pages/HomePage';
import LuxuryCarsPage from './pages/LuxuryCarsPage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import FAQPage from './pages/FAQPage';
import ContactPage from './pages/ContactPage';

// Components
import Navbar, { TopBar } from './components/Navbar';
import BookingModal from './components/BookingModal';

// Data
import sampleCars from './data/sampleCars';

// Constants
const API_URL = '/api.php';

// Public Layout Component
const PublicLayout = ({ children, isDark, toggleTheme }) => (
  <>
    <TopBar isDark={isDark} />
    <Navbar isDark={isDark} toggleTheme={toggleTheme} />
    {children}
  </>
);

// Main App Component
function App() {
  const [isDark, setIsDark] = useState(true);
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bookingModal, setBookingModal] = useState({ isOpen: false, car: null });

  const toggleTheme = () => setIsDark(!isDark);
  
  const openBookingModal = (car) => setBookingModal({ isOpen: true, car });
  const closeBookingModal = () => setBookingModal({ isOpen: false, car: null });

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await axios.get(`${API_URL}?action=list`);
        if (response.data.success && response.data.data.length > 0) {
          setCars(response.data.data);
        } else {
          setCars(sampleCars);
        }
      } catch (error) {
        console.log('Using sample data');
        setCars(sampleCars);
      } finally {
        setLoading(false);
      }
    };

    const timeout = setTimeout(() => setLoading(false), 2000);
    fetchCars();
    return () => clearTimeout(timeout);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[#c9a962] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <BookingModal 
        isOpen={bookingModal.isOpen} 
        onClose={closeBookingModal} 
        car={bookingModal.car} 
        isDark={isDark} 
      />
      <Routes>
        <Route path="/" element={<PublicLayout isDark={isDark} toggleTheme={toggleTheme}><HomePage cars={cars} isDark={isDark} openBookingModal={openBookingModal} /></PublicLayout>} />
        <Route path="/luxury-cars" element={<PublicLayout isDark={isDark} toggleTheme={toggleTheme}><LuxuryCarsPage cars={cars} isDark={isDark} openBookingModal={openBookingModal} /></PublicLayout>} />
        <Route path="/about" element={<PublicLayout isDark={isDark} toggleTheme={toggleTheme}><AboutPage isDark={isDark} /></PublicLayout>} />
        <Route path="/services" element={<PublicLayout isDark={isDark} toggleTheme={toggleTheme}><ServicesPage isDark={isDark} /></PublicLayout>} />
        <Route path="/faq" element={<PublicLayout isDark={isDark} toggleTheme={toggleTheme}><FAQPage isDark={isDark} /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout isDark={isDark} toggleTheme={toggleTheme}><ContactPage isDark={isDark} /></PublicLayout>} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard/*" element={<AdminDashboard />} />
        <Route path="/admin/messages" element={<AdminMessages />} />
      </Routes>
    </Router>
  );
}

export default App;
